import Service from "../../../Services/index";
const insurance = {
    namespaced: true,
    state: {
        insurance_fee : [],
        insurance_data : [],
        form :{
            insurance_total : "" ,
        },
        dataPaginate:{
            current_page :1,
            from : 1,
            last_page : 1,
            per_page : 1,
            total : 1,
            to : 1
        },
        search :{
            driver:""
        },
    },
    mutations: {
        SET_INSURANCE_FEE :(state, res) => {
            state.insurance_fee = res.data;
            state.dataPaginate = {
                current_page : res.current_page,
                    from : res.form,
                    last_page : res.last_page,
                    per_page : res.per_page,
                    total : res.total,
                    to : res.total
            }
        },
        SET_INSURANCE_TOTAL :(state,res)=>{
            if(res){
                state.form.insurance_total = res.insurance_total;
            }
            else{
                state.form.insurance_total = "";
            }
        },
        SET_INSURANCE_DATA :(state, res) => {
            state.insurance_data = res.data;
            state.dataPaginate = {
                current_page : res.current_page,
                from : res.form,
                last_page : res.last_page,
                per_page : res.per_page,
                total : res.total,
                to : res.total
            }
        },
        CLEAR_SEARCH:(state)=>{
            state.search  ={
                driver : ""
            }
        }

    },
    actions: {
        setInsuranceFee({ commit },page=1) {
            return Service.InsuranceFee.getInsurance(page)
                .then(data => {
                    commit("SET_INSURANCE_FEE", data);
                });
        },
        save({commit},data){
          return Service.InsuranceFee.createInsurance(data)  ;
        },
        editInsuranceFee({commit},data){
            const fee = {
                insurance_fee_total : parseFloat(data)
            };
            return Service.InsuranceFee.editInsurance(fee)
        },
        getInsuranceTotal({commit}){
            return Service.InsuranceFee.getInsuranceTotal().then(res=>{
                commit("SET_INSURANCE_TOTAL",res)
            })
        },
        searchInsurance({commit},{page=1,driver}){
            return Service.InsuranceFee.search(page,driver)
                .then(data=>{
                    commit("SET_INSURANCE_FEE",data)
                })
        },
        clearSearch({commit}){
            commit("CLEAR_SEARCH");
        },
        /*update 5/5/2020*/
        showInsurance({commit},{driver_id,page}){
            return Service.InsuranceFee.showInsurance(driver_id,page).then(res=>{
                commit('SET_INSURANCE_DATA',res);
            });
        },
        deleteInsurance({commit},id){
            return Service.InsuranceFee.deleteInsurance(id);
        }
    }
};
export default insurance;